import React from 'react';
import PropTypes from 'prop-types';

import style from './SingleLineData.module.css';

const ClientPanelSingleLineData = React.memo(
  ({
    labelType = '',
    labelStyle = {},
    label,
    valueType = '',
    valueStyle = {},
    value = '',
    type,
    contentStyle = {},
  }) => {
    const getLabel = () => {
      switch (labelType) {
        case 'image':
          return <img style={labelStyle} src={label} alt="" />;
        case 'span':
          return <span style={labelStyle}>{label}: </span>;
        default:
          return <></>;
      }
    };

    const getValue = () => {
      switch (valueType) {
        case 'anchor':
          return (
            <a
              style={valueStyle}
              rel="noopener noreferrer"
              target="_blank"
              href={value}
            >
              {value}
            </a>
          );
        case 'mail':
          return <a href={`mailto:${value}`}>{value}</a>;
        case 'div':
          return <div style={valueStyle}>{value}</div>;
        default:
          return (
            <span style={valueStyle} className={style.value}>
              {value}
            </span>
          );
      }
    };

    switch (type) {
      case 'custom':
        return (
          <div className={style.content}>
            {getLabel()}
            {getValue()}
          </div>
        );
      default:
        const testId = `client-page-${label
          ?.toLowerCase()
          ?.replace(/[^a-zA-Z]/g, '-')}-label`;

        return (
          <div className={style.content} style={contentStyle}>
            <span className={style.label}>{label}: </span>
            <span className={style.value} data-testid={testId}>
              {value}
            </span>
          </div>
        );
    }
  },
);

ClientPanelSingleLineData.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string.isRequired,
  labelType: PropTypes.string,
  valueType: PropTypes.string,
  labelStyle: PropTypes.shape({}),
  valueStyle: PropTypes.shape({}),
  contentStyle: PropTypes.shape({}),
};

export default ClientPanelSingleLineData;
